import { CryptoRepository, MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

angular.module('controllers')
    .controller('Crypto', ($scope, Util, JWT, $http, $state, $rootScope) => {

        $scope.activeTab = $state.params.tab || 'mining';
        $scope.miningIsLoading = true;
        $scope.walletIsLoading = true;
        $scope.txHistoryIsLoading = true;
        $scope.payoutConfigIsLoading = true;

        const { cryptoRestApi } = CWCONFIG;

        if (!CWCONFIG.showCrypto) {

            return;

        }

        Promise.allSettled = (promises) => {

            const mappedPromises = promises.map(p => p
                .then(value => ({
                    status: 'fulfilled',
                    value,
                }))
                .catch(reason => ({
                    status: 'rejected',
                    reason,
                })));
            return Promise.all(mappedPromises);

        };

        $scope.switchTab = (tabId, tabName) => {

            $scope.activeTab = tabId;

            $state.go('root.dashboard.crypto', {
                tab: tabId,
            });

            Mixpanel.send(`Connect Web Crypto ${tabName} Tab Click`);

        };

        $scope.disabledMiningModalClosed = sessionStorage.getItem('disabledMiningModalClosed');

        $scope.openWallet = () => {

            sessionStorage.setItem('disabledMiningModalClosed', true);

            $scope.activeTab = 'wallet';

            $state.go('root.dashboard.crypto', {
                tab: 'wallet',
            });

        };

        $scope.closeDisabledMiningModal = () => {

            sessionStorage.setItem('disabledMiningModalClosed', true);
            $scope.disabledMiningModalClosed = sessionStorage.getItem('disabledMiningModalClosed');

        };

        $scope.getHashRate = (hash, resultType) => {

            let updatedHash = hash / (1000 * 1000);
            let hashValue;

            if (updatedHash / 1000 > 1) {

                updatedHash = hash / 1000;

            }
            if (resultType && resultType === 'number') {

                hashValue = Util.toFixed(updatedHash, 1);

            } else {

                hashValue = `${Util.toFixed(updatedHash, 1)} MH/s`;

            }

            return hashValue;

        };

        let nortonGuid;
        const token = Util.getToken();

        if (token) {

            const decodedToken = JWT.getTokenPayload(token);

            if ('aguid' in decodedToken) {

                nortonGuid = decodedToken.aguid;
                $rootScope.nortonGuid = nortonGuid;

            }

        }

        // Get Wallets
        const getBalance = () =>
            $http({
                method: 'GET',
                url: `${cryptoRestApi}/wallet/api/balance/${nortonGuid}/`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-nlok-user-agent': 'ConnectWeb/1.0/Web',
                },

            }).then((response) => {

                CryptoRepository.replace('wallets', response.data.wallets);
                const pendingBalances = {};

                Object.keys(response.data.wallets).map((key) => {

                    pendingBalances[key] = response.data.wallets[key].pendingBalance;
                    return pendingBalances;

                });

                CryptoRepository.replace('pendingBalances', pendingBalances);
                $scope.walletIsLoading = false;

            }).catch((error) => {

                if (error.status === 404) {

                    $http({
                        method: 'POST',
                        url: `${cryptoRestApi}/wallet/api/wallet`,
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'x-nlok-user-agent': 'ConnectWeb/1.0/Web',
                        },
                        data: {
                            nortonGuid,
                            currency: 'ETH',
                        },
                    }).then(() => {

                        getBalance();

                    }).catch(() => {

                        getBalance();

                    });

                }

                CryptoRepository.replace('wallets', {});
                CryptoRepository.replace('pendingBalances', {});

                Mixpanel.send('ConnectWeb Crypto Error', {
                    'Error Code': error.status,
                    'Error Name': error.data ? error.data : 'No error message',
                    Resource: 'GET balance',
                });

            });

        // Used for mixpanel
        const getBalancePromise =
            $http({
                method: 'GET',
                url: `${cryptoRestApi}/wallet/api/balance/${nortonGuid}/`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-nlok-user-agent': 'ConnectWeb/1.0/Web',
                },

            }).then((response) => {

                CryptoRepository.replace('wallets', response.data.wallets);
                const pendingBalances = {};

                Object.keys(response.data.wallets).map((key) => {

                    pendingBalances[key] = response.data.wallets[key].pendingBalance;
                    return pendingBalances;

                });

                CryptoRepository.replace('pendingBalances', pendingBalances);

            }).catch(() => {

                CryptoRepository.replace('wallets', {});
                CryptoRepository.replace('pendingBalances', {});

            });

        // Get Price
        const getPrices = $http({

            method: 'GET',
            url: `${cryptoRestApi}/pricing/api/price?symbol=ETH`,
            headers: {
                Authorization: `Bearer ${token}`,
                'x-nlok-user-agent': 'ConnectWeb/1.0/Web',
            },

        }).then((response) => {

            CryptoRepository.replace('prices', response.data);
            getBalance();

        }).catch((error) => {

            CryptoRepository.replace('prices', []);
            Mixpanel.send('ConnectWeb Crypto Error', {
                'Error Code': error.status,
                'Error Name': error.data ? error.data : 'No error message',
                Resource: 'GET price',
            });

        });

        // Get Tx History
        const getTxHistory = $http({

            method: 'GET',
            url: `${cryptoRestApi}/wallet/api/txHistory/${nortonGuid}/`,
            headers: {
                Authorization: `Bearer ${token}`,
                'x-nlok-user-agent': 'ConnectWeb/1.0/Web',
            },

        }).then((response) => {

            CryptoRepository.replace('transactions', response.data.transactionList.reverse());
            $scope.txHistoryIsLoading = false;

        }).catch((error) => {

            CryptoRepository.replace('transactions', []);
            $scope.txHistoryIsLoading = false;
            Mixpanel.send('ConnectWeb Crypto Error', {
                'Error Code': error.status,
                'Error Name': error.data ? error.data : 'No error message',
                Resource: 'GET txHistory',
            });

        });

        // Get Tx Fees
        const getTXFees = $http({

            method: 'GET',
            url: `${cryptoRestApi}/wallet/api/txFees`,
            headers: {
                Authorization: `Bearer ${token}`,
                'x-nlok-user-agent': 'ConnectWeb/1.0/Web',
            },

        }).then((response) => {

            CryptoRepository.replace('fees', response.data);

        }).catch((error) => {

            CryptoRepository.replace('fees', []);
            Mixpanel.send('ConnectWeb Crypto Error', {
                'Error Code': error.status,
                'Error Name': error.data ? error.data : 'No error message',
                Resource: 'GET txFees',
            });

        });

        // Get Payout Config
        const getPayoutConfig = $http({
            method: 'GET',
            url: `${cryptoRestApi}/payouts/api/payoutConfig?currency=ETH`,
            headers: {
                Authorization: `Bearer ${token}`,
                'x-nlok-user-agent': 'ConnectWeb/1.0/Web',
            },

        }).then((response) => {

            CryptoRepository.replace('payoutConfig', response.data.payoutConfig);

        }).catch((error) => {

            CryptoRepository.replace('payoutConfig', {});
            Mixpanel.send('ConnectWeb Crypto Error', {
                'Error Code': error.status,
                'Error Name': error.data ? error.data : 'No error message',
                Resource: 'GET payoutConfig',
            });

        });

        const pendingBalanceArray = [getPayoutConfig, getBalancePromise];

        Promise.allSettled(pendingBalanceArray).then(() => {

            $scope.payoutConfigIsLoading = false;

        });

        const cryptoResources =
            [getPrices, getTxHistory, getTXFees,
                getPayoutConfig, getBalancePromise];

        Promise.allSettled(cryptoResources).then(() => {

            const cryptoData = CryptoRepository.getAll();
            const cryptoRigs = CryptoRepository.getAllRigs();

            let overallHashRate = 0;

            if (cryptoRigs.length > 0) {

                cryptoRigs.forEach((rig) => {

                    if (!rig.hashRate) {

                        rig.hashRate = 0;

                    }

                    overallHashRate += parseFloat(rig.hashRate);

                });

            }

            if (cryptoData.prices.conversionRateMap) {

                cryptoData.currencies = Object.keys(cryptoData.prices.conversionRateMap).sort();
                const ethPrice =
                    Util.toFixed(cryptoData.prices.conversionRateMap.USD, 2);
                Mixpanel.setCommonProperty('ETH Price USD', ethPrice);

            }

            if (Object.keys(cryptoData.wallets).length > 0) {

                Mixpanel.setCommonProperty('ETH Balance', Util.toFixed(cryptoData.wallets.ETH.balance, 6));

            }

            if (Object.keys(cryptoData.wallets).length > 0 && cryptoData.prices.conversionRateMap) {

                let moneyBalance = 0;
                let cryptoBalance = 0;
                Object.keys(cryptoData.wallets).forEach((key) => {

                    moneyBalance +=
                    cryptoData.prices.conversionRateMap[$rootScope.cryptoCurrency] *
                    cryptoData.wallets[key].balance;
                    cryptoBalance += cryptoData.wallets[key].balance;
                    $rootScope.cryptoSymbol = key;

                });

                $rootScope.moneyBalance = `${Util.toFixed(moneyBalance, 2)}`;
                $rootScope.cryptoBalance = `${Util.toFixed(cryptoBalance, 6)}`;

            }

            if (Object.keys(cryptoData.pendingBalances).length > 0) {

                Mixpanel.setCommonProperty('ETH Pending', Util.toFixed(cryptoData.pendingBalances.ETH, 6));

            }

            Mixpanel.setCommonProperty('Rig count', cryptoRigs.length);
            Mixpanel.setCommonProperty('Hashrate', $scope.getHashRate(overallHashRate, 'number'));

            const user = MeRepository.getMyUser();
            const tfaStatus = user.attributes.status_tfa === 'active' ? 'tfaEnabled' : 'tfaDisabled';
            const dateTFAactivated = user.attributes.date_tfa_activated;

            const getDateDifference = (date) => {

                const now = moment();
                const end = moment(date);
                const duration = moment.duration(now.diff(end));
                const days = Util.toFixed(duration.asHours(), 2);
                return days;

            };

            if (dateTFAactivated) {

                if (parseFloat(getDateDifference(dateTFAactivated)) > 24) {

                    Mixpanel.setCommonProperty('TFA State', 'active');

                } else {

                    Mixpanel.setCommonProperty('TFA State', 'pending');

                }

            } else if (!dateTFAactivated && tfaStatus === 'tfaEnabled') {

                Mixpanel.setCommonProperty('TFA State', 'active');

            } else if (!dateTFAactivated && tfaStatus === 'tfaDisabled') {

                Mixpanel.setCommonProperty('TFA State', 'inactive');

            }

            Mixpanel.send('ConnectWeb Crypto Open', {
                Tab: $scope.activeTab,
            });

        });

    });



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/crypto/crypto.js